import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

export const DataTableGridLoadingSkeleton = () => (
  <div className="relative grid h-full grid-cols-[repeat(auto-fill,minmax(var(--thumbnail-size),1fr))] content-start items-start bg-ui-container p-6">
    {Array.from(Array(16)).map((_, index) => (
      <div className="p-6" key={`gallery-skeleton-${index}`}>
        <div data-testid={`gallery-skeleton-${index}`} className={cn('grid gap-2')}>
          <Skeleton className="flex aspect-square h-auto w-full bg-ui-panel!" />
          <div className="mt-0! flex flex-col justify-center gap-2 text-sm">
            <Skeleton className="h-4 w-11/12 bg-ui-panel!" />
            <Skeleton className="h-6 w-9/12 bg-ui-panel!" />
          </div>
        </div>
      </div>
    ))}
  </div>
);
